import { AnalyticsStore } from 'common/stores/AnalyticsStore';
import { FormatStateStore } from 'common/stores/FormatStateStore';
import { MraidUnloadCallHandler } from 'common/stores/handlers/MraidUnloadCallHandler';
import { MraidStore } from 'common/stores/MraidStore';
import { MraidNoUnloadOnClickHandler } from '../../../../common/stores/handlers/MraidNoUnloadOnClickHandler';
import { UserClickHandler } from '../../../../common/stores/handlers/UserClickHandler';
import { DisplayConfigType } from '../config';

interface Props {
  adContext: AdContext;
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
  formatStateStore: FormatStateStore;
  userClickHandler: UserClickHandler;
  formatConfig: DisplayConfigType;
}

export function getMraidUnloadCallHandler({
  formatStateStore,
  mraidStore,
  analyticsStore,
  userClickHandler,
  adContext,
  formatConfig
}: Props): MraidUnloadCallHandler {
  switch (adContext.adUnitType) {
    case 'medium_rectangle':
    case 'banner_320x50':
    case 'standard_banners':
    case 'in_article':
      return new MraidNoUnloadOnClickHandler({
        formatStateStore,
        mraidStore,
        analyticsStore,
        userClickHandler,
        adContext,
        formatConfig
      });
    default:
      return new MraidUnloadCallHandler({
        formatStateStore,
        mraidStore,
        analyticsStore,
        userClickHandler,
        adContext,
        formatConfig
      });
  }
}
